import classNames from "classnames";
import "./Heading.css";

export type HeadingProps = {
    className?: string;
    fontStyle?: "italic";
    disabled?: boolean;
    children: React.ReactNode;
};

function H1(props: HeadingProps) {
    const { className, disabled, fontStyle, children } = props;

    return (
        <h1
            className={classNames("web-lib__heading text-text-primary", className, {
                "web-lib__heading--italic": fontStyle === "italic",
                "web-lib__heading--disabled": disabled,
            })}
        >
            {children}
        </h1>
    );
}

function H2(props: HeadingProps) {
    const { className, fontStyle, disabled, children } = props;

    return (
        <h2
            className={classNames("web-lib__heading text-text-primary", className, {
                "web-lib__heading--italic": fontStyle === "italic",
                "web-lib__heading--disabled": disabled,
            })}
        >
            {children}
        </h2>
    );
}

function H3(props: HeadingProps) {
    const { className, fontStyle, disabled, children } = props;

    return (
        <h3
            className={classNames("web-lib__heading text-text-primary", className, {
                "web-lib__heading--italic": fontStyle === "italic",
                "web-lib__heading--disabled": disabled,
            })}
        >
            {children}
        </h3>
    );
}

function H4(props: HeadingProps) {
    const { className, fontStyle, disabled, children } = props;

    return (
        <h4
            className={classNames("web-lib__heading text-text-primary", className, {
                "web-lib__heading--italic": fontStyle === "italic",
                "web-lib__heading--disabled": disabled,
            })}
        >
            {children}
        </h4>
    );
}

function H5(props: HeadingProps) {
    const { className, fontStyle, disabled, children } = props;

    return (
        <h5
            className={classNames("web-lib__heading text-text-primary", className, {
                "web-lib__heading--italic": fontStyle === "italic",
                "web-lib__heading--disabled": disabled,
            })}
        >
            {children}
        </h5>
    );
}

function H6(props: HeadingProps) {
    const { className, fontStyle, disabled, children } = props;

    return (
        <h6
            className={classNames("web-lib__heading text-text-primary", className, {
                "web-lib__heading--italic": fontStyle === "italic",
                "web-lib__heading--disabled": disabled,
            })}
        >
            {children}
        </h6>
    );
}

const Heading = {
    H1,
    H2,
    H3,
    H4,
    H5,
    H6,
};

export default Heading;
